import {Snackbar} from "@mui/material";
import {useCallback, useEffect, useState} from "react";
import {ToastDetail} from "@app/events";

const ToastComp = () => {
    const [toastMessage, setToastMessage] = useState<string>('');

    const handler = useCallback(({ detail }: CustomEvent<ToastDetail>) => {
        setToastMessage(detail.message);
    }, []);

    useEffect(() => {
        window.addEventListener("eToast", handler as any);

        return () => {
            window.removeEventListener("eToast", handler as any);
        };
    }, []);

        return (
            <Snackbar
                sx={{zIndex: 10001}}
                open={!!toastMessage}
                autoHideDuration={2000}
                onClose={() => setToastMessage('')}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                message={toastMessage}
            />
        )

}

export default ToastComp;